<script lang="ts">
	import { onMount } from 'svelte'
	import Alert from '@isoftdata/svelte-alert'
	import Button from '@isoftdata/svelte-button'
	import Icon from '@isoftdata/svelte-icon'
	import type { SvelteAsr } from 'types/common'
	import { populateSessionFromCookie } from 'utility/oauth-helper'

	export let asr: SvelteAsr
	export let error: string | undefined

	let isLoading = true
	let errorMessage: string | undefined = error

	onMount(async () => {
		if (error) {
			isLoading = false
			return
		}

		try {
			await populateSessionFromCookie()
			// Defer navigation so abstract-state-router finishes activating this
			// state before we ask it to destroy it.
			setTimeout(() => asr.go('app'), 0)
		} catch (err) {
			isLoading = false
			errorMessage = (err as Error)?.message ?? 'OAuth login failed.'
		}
	})
</script>

{#if isLoading}
	<div class="d-flex justify-content-center align-items-center vh-100">
		<div class="text-center">
			<Icon isLoading class="mb-3" />
			<p class="text-muted">Completing OAuth login...</p>
		</div>
	</div>
{:else if errorMessage}
	<div class="d-flex justify-content-center align-items-center vh-100">
		<div class="text-center">
			<Alert
				color="danger"
				heading="Login failed:"
				message={errorMessage}
				show
			/>
			<Button
				color="link"
				class="p-0"
				onclick={() => asr.go('login')}>Return to login</Button
			>
		</div>
	</div>
{/if}
